export default {"src":"/_next/static/media/event.7ec6cb20.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};